const BASE_URL = process.env.REACT_APP_API_URL || '';

const authFetch = (path, options = {}) => {
  const token = localStorage.getItem('token');
  return fetch(`${BASE_URL}/api${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  }).then(r => r.json());
};

class FreeTrialService {
  async getTrialStatus() {
    try {
      return await authFetch('/free-trial/status');
    } catch (error) {
      console.error('Get trial status error:', error);
      return { claimed: false, eligible: false, expired: false, eligibleUntil: null };
    }
  }

  async claimTrial(customerId, email, phone, paymentId, selectedProducts, deliverySchedule) {
    try {
      return await authFetch('/free-trial/claim', {
        method: 'POST',
        body: JSON.stringify({ customerId, email, phone, paymentId, selectedProducts, deliverySchedule }),
      });
    } catch (error) {
      console.error('Claim trial error:', error);
      throw error;
    }
  }

  async getTrialConfig() {
    try {
      return await authFetch('/free-trial/config');
    } catch (error) {
      return { SHOTS_COUNT: 5, VALIDITY_DAYS: 3, MAX_SHOTS_PER_DAY: 2 };
    }
  }
}

export default new FreeTrialService();
